
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4915_18122)"}},[_c('path',{attrs:{"d":"M9.624 14.565a17.954 17.954 0 007.81 7.81l2.607-2.607c.32-.32.795-.427 1.21-.285 1.327.439 2.76.676 4.23.676.652 0 1.186.533 1.186 1.185v4.136c0 .652-.534 1.185-1.186 1.185-11.128 0-20.148-9.019-20.148-20.148 0-.652.534-1.185 1.186-1.185h4.148c.652 0 1.185.533 1.185 1.185 0 1.482.237 2.904.675 4.231.13.415.036.877-.296 1.21l-2.607 2.607z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4915_18122"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    